import React from 'react'
import {connect} from 'react-redux'
import TextLine from '../../text/TextLine.js'
import {handleRolloutStep} from '../lifecycle/handle-new-rollout.js'
import {setBattleValue} from '../../redux-actions/battle-actions.js'
import store from '../../init/store.js'
import {handleBattleOver} from './handleBattleOver.js'

class RolloutMessageBox extends React.Component {

  handleTextLineDone() {

    //TODO: The UX here might change, but for now just auto fire the "I've seen this text line" trigger when text is done revealing
    setTimeout(() => { //Delay for effect

      //Move to next rollout step if battle is not over
      if (this.props.rolloutId !== "rollout_battle-over") {

        //Increment the rolloutIndex and then hit the step
        setBattleValue({
          rolloutExecutingIndex: store.getState().battle.rolloutExecutingIndex + 1
        });

        //Add a little extra delay if this is the first message
        if (this.props.rolloutId === "rollout_battle-starting") {
          setTimeout(handleRolloutStep, 700);
        } else {
          //FOR ALL OTHER MESSAGES - Tell rollout to move on to next step
          handleRolloutStep();
        }

      } else {

        //The battle is over!
        setTimeout( () => {
          //Activate the transition overlay (ArenaTransitionOverlay) to fade IN to white
          setBattleValue({
            arenaTransitionOverlay: {
              transition: "fadeIn",
              callback() {
                //console.log('complete!')
                  //Provide the "next steps" screen after a Quick battle (both Online and Offline)
                  handleBattleOver();
              }
            }
          })

        }, 800)
      }
    }, 600)
  }

  getStyle() {
    const baseStyle = {
      fontSize: "0.8em",
      lineHeight: "2.4em",
      //background: "#052128" //This attempts to help the weird text flashing on the left side,
      // position: "absolute",
      // bottom: 0,
      // zIndex:4, //characters are 1 and 2, submission menu is 3
      // background: "#333",
    };

    //Get MOBILE styles
    if (this.props.viewportMode === "portrait") {
      return {
        ...baseStyle,
        // left:0,
        // right: 0,
        // height: this.props.vW * 30,
        padding: "0.5em"
      }
    }

    //Get DESKTOP styles
    if (this.props.viewportMode === "landscape") {
      return {
        ...baseStyle,
        height: this.props.vW * 15,
        padding: "1em 0.5em",
      }
    }

  }


  render() {

    if (!this.props.arenaIsRolloutShowing) {
      return null
    }


    if (this.props.rolloutData && this.props.rolloutData.length > 0) {
      const uniqueTextLineKey = this.props.lastSeenTextMessageKey; //Tell React to replace this container with new Mounting for TextLine content changes

      return (
        <div className="RolloutMessageBox" style={this.getStyle()} key={uniqueTextLineKey}>
         <TextLine
           lineData={this.props.lastSeenTextMessage}
           onDone={this.handleTextLineDone.bind(this)}
         />
        </div>
      );
    }

    //return (<div>no rollout</div>)
    return null
  }
}



export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode,


    rolloutId: state.battle.rolloutId,
    rolloutData: state.battle.rolloutData,
    lastSeenTextMessage: state.battle.lastSeenTextMessage.content,
    lastSeenTextMessageKey: state.battle.lastSeenTextMessage.key,

    //Flag for showing the rollout message
    arenaIsRolloutShowing: state.battle.arenaIsRolloutShowing
  }
})(RolloutMessageBox)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/RolloutMessageBox.js